import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
import RecieptDocumentRE from "./ReceiptDocumentRE";

const RecieptPreviewRE = () => {
    const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

    const location = useLocation();
    const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
    const navigate = useNavigate();
    const rvPrintData = location.state?.rvPrintData;
    console.log("RV Print Data:", rvPrintData);
    const [receiptData, setReceiptData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const rvNo = rvPrintData.RV_NO.trim();

        fetchRecieptReport(rvNo);
    }, [rvPrintData]);

    const fetchRecieptReport = async (rvNo) => {
        try {
            const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];
            if (!apiPaths[0]) return;

            const apiUrl = `${apiPaths[0].API_CONFIG}/api/CRMReportGenerator/${COMPANY_CODE}/RCPT_PRINT/${rvNo}/${DEPARTMENT}/${rvPrintData?.JVTYPE}/-/-/-/-`;
            const res = await axios.get(apiUrl);

            // setReceiptData(res.data || []);

            // const filteredData = Array.isArray(res.data)
            //   ? res.data.filter((item) => item.pdc_acc === "X")
            //   : [];

            setReceiptData(res.data || []);
        } catch (err) {
            console.error("Error fetching receipt:", err);
            setReceiptData([]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mx-4">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-normal my-4">Receipt RE Print Preview</h2>

                <button
                    onClick={() => navigate('/tenancyContractRegister', { state: { activeTab: 'receipt_details' } })}

                    className="mb-3 relative bg-gray-600 text-white px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center"
                >
                    <span className="mr-10">Back</span>
                    <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-full flex items-center justify-center">
                        <FaArrowLeft className="text-gray-600" />
                    </div>
                </button>
            </div>

            <div className="flex flex-col items-center h-screen">
                {loading ? (
                    <div className="text-center text-gray-500 mt-10">
                        Loading Receipt Data...
                    </div>
                ) : (
                    <>
                        <div className="w-full h-screen border border-gray-300 mb-4">
                            <PDFViewer width="100%" height="100%">
                                <RecieptDocumentRE accountData={receiptData} />
                            </PDFViewer>
                        </div>

                        <div className="mt-4 mb-6">
                            <PDFDownloadLink
                                document={<RecieptDocumentRE accountData={receiptData} />}
                                fileName={`ReceiptVoucher_${rvPrintData.RV_NO.trim() || "print"
                                    }.pdf`}
                                className="bg-blue-500 text-white px-4 py-2 rounded"
                            >
                                {({ loading }) =>
                                    loading ? "Preparing PDF..." : "Download Receipt Voucher"
                                }
                            </PDFDownloadLink>
                        </div>
                    </>
                )}
            </div>

            {/* <div className="w-full h-screen border">
        <PDFViewer width="100%" height="100%">
          <RecieptDocument accountData={receiptData} />
        </PDFViewer>
      </div>

      <div className="mt-4 mb-6">
        <PDFDownloadLink
          document={<RecieptDocument accountData={receiptData} />}
          fileName="receipt.pdf"
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          {({ loading }) => (loading ? "Loading..." : "Download Statement")}
        </PDFDownloadLink>
      </div> */}
        </div>
    );
};

export default RecieptPreviewRE;
